import * as i1 from '@angular/common';
import { CommonModule, DatePipe } from '@angular/common';
import * as i0 from '@angular/core';
import { InjectionToken, EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, Pipe, ViewChild, inject, ChangeDetectorRef, Injectable, Optional, Inject, NgModule } from '@angular/core';
import * as i1$1 from '@angular/forms';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i3$1 from '@capturum/ui/button';
import { CapturumButtonModule } from '@capturum/ui/button';
import { Subject, debounceTime, takeUntil, ReplaySubject, filter as filter$1, BehaviorSubject } from 'rxjs';
import { startWith, map, filter, takeUntil as takeUntil$1, distinctUntilKeyChanged } from 'rxjs/operators';
import * as i2 from '@capturum/ui/input';
import { CapturumInputModule } from '@capturum/ui/input';
import * as i1$2 from '@capturum/ui/api';
import { FilterMatchMode, DateFormat, CapturumSharedModule, CapturumDialogService } from '@capturum/ui/api';
import * as i2$1 from '@capturum/ui/dropdown';
import { CapturumDropdownModule } from '@capturum/ui/dropdown';
import * as i2$2 from '@capturum/ui/multi-select';
import { CapturumMultiSelectModule } from '@capturum/ui/multi-select';
import * as i3 from '@capturum/ui/calendar';
import { CapturumCalendarModule } from '@capturum/ui/calendar';
import * as i2$3 from '@capturum/ui/table';
import { RangeFilterComponent, CapturumTableModule } from '@capturum/ui/table';
import * as i2$4 from '@capturum/ui/checkbox';
import { CapturumCheckboxModule } from '@capturum/ui/checkbox';
import { toString, apply, parse } from 'duration-fns';
import { isValid, intervalToDuration, isBefore } from 'date-fns';
import * as i2$5 from '@angular/router';
import * as i6 from 'primeng/api';
import * as i7 from '@capturum/ui/sidebar';
import { CapturumSidebarModule } from '@capturum/ui/sidebar';
import * as i8 from 'primeng/chips';
import { ChipsModule } from 'primeng/chips';
import { SidebarModule } from 'primeng/sidebar';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CapturumInputSwitchModule } from '@capturum/ui/input-switch';
function CapturumDynamicFilterLayoutComponent_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
  }
}
function CapturumDynamicFilterLayoutComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵlistener("click", function CapturumDynamicFilterLayoutComponent_div_6_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.resetFilter.emit());
    });
    i0.ɵɵelement(1, "i", 7);
    i0.ɵɵelementEnd();
  }
}
const _c0 = ["*"];
const _c1 = function (a0) {
  return {
    search: a0
  };
};
function DynamicFiltersSidebarComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "cap-dynamic-filter", 10);
    i0.ɵɵlistener("updateValue", function DynamicFiltersSidebarComponent_div_3_Template_cap_dynamic_filter_updateValue_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.setSidebarFilter($event));
    });
    i0.ɵɵpipe(2, "filterField");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const filter_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate2("sidebar-filter filter ", ctx_r0.filterStyleClass, " ", filter_r2 == null ? null : filter_r2.styleClass, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c1, (filter_r2 == null ? null : filter_r2.field) === "global_search"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("activeFilter", i0.ɵɵpipeBind2(2, 8, ctx_r0.activeFilters, filter_r2.field))("filterConfig", filter_r2);
    i0.ɵɵattribute("data-test", "filter-" + filter_r2.field);
  }
}
function DynamicFiltersSidebarComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "cap-dynamic-filter", 10);
    i0.ɵɵlistener("updateValue", function DynamicFiltersSidebarComponent_div_5_Template_cap_dynamic_filter_updateValue_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r6 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r6.setSidebarFilter($event));
    });
    i0.ɵɵpipe(2, "filterField");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const filter_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate2("sidebar-filter filter ", ctx_r1.filterStyleClass, " ", filter_r5 == null ? null : filter_r5.styleClass, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c1, (filter_r5 == null ? null : filter_r5.field) === "global_search"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("activeFilter", i0.ɵɵpipeBind2(2, 8, ctx_r1.activeFilters, filter_r5.field))("filterConfig", filter_r5);
    i0.ɵɵattribute("data-test", "filter-" + filter_r5.field);
  }
}
function CapturumDynamicFiltersComponent_div_0_ng_container_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "cap-dynamic-filter", 12);
    i0.ɵɵlistener("updateValue", function CapturumDynamicFiltersComponent_div_0_ng_container_2_div_1_Template_cap_dynamic_filter_updateValue_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r8 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r8.handleUpdateValue($event));
    });
    i0.ɵɵpipe(2, "filterField");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const filter_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate2("filter ", ctx_r7.filterStyleClass, " ", filter_r5 == null ? null : filter_r5.styleClass, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c1, (filter_r5 == null ? null : filter_r5.field) === "global_search"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("activeFilter", i0.ɵɵpipeBind2(2, 8, ctx_r7.activeFilters, filter_r5.field))("filterConfig", filter_r5);
    i0.ɵɵattribute("data-test", "filter-" + filter_r5.field);
  }
}
function CapturumDynamicFiltersComponent_div_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumDynamicFiltersComponent_div_0_ng_container_2_div_1_Template, 3, 13, "div", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const index_r6 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", index_r6 < ctx_r2.maxFiltersShown || !ctx_r2.sidebarFiltering);
  }
}
function CapturumDynamicFiltersComponent_div_0_cap_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cap-button", 13);
    i0.ɵɵlistener("click", function CapturumDynamicFiltersComponent_div_0_cap_button_5_Template_cap_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r11 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r11.refreshFilters());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("icon", (ctx_r3.filterConfig.icons == null ? null : ctx_r3.filterConfig.icons.refresh) || "")("label", (ctx_r3.filterConfig.texts == null ? null : ctx_r3.filterConfig.texts.refresh) || "Refresh");
  }
}
function CapturumDynamicFiltersComponent_div_0_cap_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cap-button", 14);
    i0.ɵɵlistener("click", function CapturumDynamicFiltersComponent_div_0_cap_button_6_Template_cap_button_click_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r13 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r13.resetFilters());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("icon", (ctx_r4.filterConfig.icons == null ? null : ctx_r4.filterConfig.icons.reset) || "")("label", (ctx_r4.filterConfig.texts == null ? null : ctx_r4.filterConfig.texts.reset) || "Reset");
  }
}
function CapturumDynamicFiltersComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 4);
    i0.ɵɵtemplate(2, CapturumDynamicFiltersComponent_div_0_ng_container_2_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 6)(4, "cap-button", 7);
    i0.ɵɵlistener("click", function CapturumDynamicFiltersComponent_div_0_Template_cap_button_click_4_listener() {
      i0.ɵɵrestoreView(_r16);
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.openFilterSidebar());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CapturumDynamicFiltersComponent_div_0_cap_button_5_Template, 1, 2, "cap-button", 8);
    i0.ɵɵtemplate(6, CapturumDynamicFiltersComponent_div_0_cap_button_6_Template, 1, 2, "cap-button", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("cap-filters ", ctx_r0.containerStyleClass, "");
    i0.ɵɵclassProp("sidebar-filtering", ctx_r0.sidebarFiltering);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.showFilters);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("hide-filter-button", ctx_r0.maxFiltersShown >= ctx_r0.filterConfig.filters.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showRefreshButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showResetButton);
  }
}
function CapturumDynamicFiltersComponent_div_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const item_r18 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", item_r18.label, " ");
  }
}
const _c2 = function () {
  return {
    display: "none"
  };
};
function CapturumDynamicFiltersComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "p-chips", 16);
    i0.ɵɵlistener("ngModelChange", function CapturumDynamicFiltersComponent_div_1_Template_p_chips_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r20);
      const ctx_r19 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r19.filteredTokens = $event);
    })("onRemove", function CapturumDynamicFiltersComponent_div_1_Template_p_chips_onRemove_1_listener($event) {
      i0.ɵɵrestoreView(_r20);
      const ctx_r21 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r21.removeFilter($event.value));
    });
    i0.ɵɵtemplate(2, CapturumDynamicFiltersComponent_div_1_ng_template_2_Template, 1, 1, "ng-template", 17);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r1.filteredTokens)("showClear", false)("inputStyle", i0.ɵɵpureFunction0(3, _c2));
  }
}
const DYNAMIC_FILTER_COMPONENTS = new InjectionToken('Components for the dynamic filter component');
let CapturumDynamicFilterLayoutComponent = /*#__PURE__*/(() => {
  class CapturumDynamicFilterLayoutComponent {
    constructor() {
      this.resetFilter = new EventEmitter();
    }
    static {
      this.ɵfac = function CapturumDynamicFilterLayoutComponent_Factory(t) {
        return new (t || CapturumDynamicFilterLayoutComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumDynamicFilterLayoutComponent,
        selectors: [["cap-dynamic-filter-layout"]],
        inputs: {
          showReset: "showReset",
          label: "label",
          iconClass: "iconClass"
        },
        outputs: {
          resetFilter: "resetFilter"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 7,
        vars: 4,
        consts: [[1, "cap-dynamic-filter-layout"], ["for", "", 4, "ngIf"], [1, "cap-dynamic-filter-layout-content"], [1, "filter-icon"], ["class", "delete-filter", 3, "click", 4, "ngIf"], ["for", ""], [1, "delete-filter", 3, "click"], [1, "fas", "fa-trash-alt"]],
        template: function CapturumDynamicFilterLayoutComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, CapturumDynamicFilterLayoutComponent_label_1_Template, 2, 1, "label", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵprojection(3);
            i0.ɵɵelementStart(4, "div", 3);
            i0.ɵɵelement(5, "i");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, CapturumDynamicFilterLayoutComponent_div_6_Template, 2, 0, "div", 4);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance(4);
            i0.ɵɵclassMap(ctx.iconClass);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showReset);
          }
        },
        dependencies: [CommonModule, i1.NgIf],
        styles: [":root{--cap-input-height: 30px;--cap-dynamic-filter-input-height: 30px;--cap-dynamic-filter-border-radius: 5px;--cap-dynamic-filter-border-width: 1px;--cap-dynamic-filters-hide-filters-on-mobile: false;--cap-dynamic-filters-filter-flex: 1;--cap-dynamic-filters-flex-wrap: wrap;--cap-dynamic-filter-width: 200px;--cap-dynamic-filter-label-font-size: 14px;--cap-dynamic-filter-label-font-weight: 600;--cap-dynamic-filter-label-font-family: \"Source Sans Pro\";--cap-dynamic-filter-label-font-color: #5f6062;--cap-dynamic-filter-placeholder-font-weight: 600;--cap-dynamic-filter-placeholder-font-color: #5f6062;--cap-dynamic-filter-icon-opacity: 1;--cap-dynamic-filter-icon-color: var(--cap-primary-color)}.cap-dynamic-filter-layout,.cap-dynamic-filter-layout .cap-dynamic-filter-layout-content{position:relative}.cap-dynamic-filter-layout .filter-icon{left:15px;top:50%;transform:translate3d(0,-50%,0);line-height:.9em}.cap-dynamic-filter-layout .filter-icon i{opacity:var(--cap-dynamic-filter-icon-opacity);color:var(--cap-dynamic-filter-icon-color);font-size:var(--cap-dynamic-filter-label-font-size)}.cap-dynamic-filter-layout .delete-filter{cursor:pointer;position:absolute;right:15px;top:47%;transform:translate3d(0,calc(-50% + 2px),0)}.cap-dynamic-filter-layout .delete-filter i{color:red}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CapturumDynamicFilterLayoutComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputFilterComponent = /*#__PURE__*/(() => {
  class InputFilterComponent {
    constructor(cdr) {
      this.cdr = cdr;
      this.updateValue = new EventEmitter();
      this.formControl = new FormControl();
      this.destroy$ = new Subject();
    }
    ngOnInit() {
      this.formControl.valueChanges.pipe(debounceTime(this.filterConfig.debounceTime || 300), startWith(this.formControl.value), map(value => value ? value?.trim() : value), filter(value => {
        return value !== this.lastUpdatedValue;
      }), takeUntil(this.destroy$)).subscribe(value => {
        this.updateFilterValue(value);
        this.lastUpdatedValue = value;
      });
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    updateFilterValue(value) {
      this.updateValue.emit(value);
    }
    setValue(value) {
      this.formControl.setValue(value, {
        emitEvent: false
      });
      this.lastUpdatedValue = value;
      this.cdr.detectChanges();
    }
    updateView() {
      this.cdr.detectChanges();
    }
    reset() {
      this.formControl.setValue(null);
    }
    static {
      this.ɵfac = function InputFilterComponent_Factory(t) {
        return new (t || InputFilterComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputFilterComponent,
        selectors: [["cap-input-filter"]],
        inputs: {
          filterConfig: "filterConfig"
        },
        decls: 4,
        vars: 11,
        consts: [[1, "cap-dynamic-input-filter", 3, "iconClass", "label", "showReset", "resetFilter"], [3, "formControl", "disabled", "placeholder"]],
        template: function InputFilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-dynamic-filter-layout", 0);
            i0.ɵɵlistener("resetFilter", function InputFilterComponent_Template_cap_dynamic_filter_layout_resetFilter_0_listener() {
              return ctx.reset();
            });
            i0.ɵɵelement(1, "cap-input", 1);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵpipe(3, "observablePipe");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_2_0;
            i0.ɵɵproperty("iconClass", ctx.filterConfig.icon)("label", ctx.filterConfig.showLabel ? ctx.filterConfig.label : "")("showReset", ctx.formControl.value && ((tmp_2_0 = ctx.filterConfig.resetFilter) !== null && tmp_2_0 !== undefined ? tmp_2_0 : true));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControl", ctx.formControl)("disabled", i0.ɵɵpipeBind1(2, 7, i0.ɵɵpipeBind1(3, 9, ctx.filterConfig.disabled)))("placeholder", ctx.filterConfig.placeholder);
            i0.ɵɵattribute("data-test", "filter-" + ctx.filterConfig.field);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.FormControlDirective, i2.CapturumInputComponent, CapturumDynamicFilterLayoutComponent, i1.AsyncPipe, i1$2.ObservablePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return InputFilterComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumDropdownFilterComponent = /*#__PURE__*/(() => {
  class CapturumDropdownFilterComponent {
    constructor(cdr) {
      this.cdr = cdr;
      this.updateValue = new EventEmitter();
      this.formControl = new FormControl();
    }
    setValue(value) {
      this.formControl.setValue(value);
      this.cdr.detectChanges();
    }
    reset() {
      this.formControl.reset();
      this.updateValue.emit(null);
    }
    updateView() {
      this.cdr.detectChanges;
    }
    static {
      this.ɵfac = function CapturumDropdownFilterComponent_Factory(t) {
        return new (t || CapturumDropdownFilterComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumDropdownFilterComponent,
        selectors: [["cap-dropdown-filter"]],
        inputs: {
          filterConfig: "filterConfig"
        },
        decls: 6,
        vars: 20,
        consts: [[1, "dynamic-dropdown-filter", 3, "label", "iconClass", "showReset", "resetFilter"], [3, "filter", "formControl", "autofocusFilter", "resetFilterOnHide", "disabled", "options", "sortAlphabetically", "placeholder", "change"]],
        template: function CapturumDropdownFilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-dynamic-filter-layout", 0);
            i0.ɵɵlistener("resetFilter", function CapturumDropdownFilterComponent_Template_cap_dynamic_filter_layout_resetFilter_0_listener() {
              return ctx.reset();
            });
            i0.ɵɵelementStart(1, "cap-dropdown", 1);
            i0.ɵɵlistener("change", function CapturumDropdownFilterComponent_Template_cap_dropdown_change_1_listener($event) {
              return ctx.updateValue.emit($event.value);
            });
            i0.ɵɵpipe(2, "async");
            i0.ɵɵpipe(3, "observablePipe");
            i0.ɵɵpipe(4, "async");
            i0.ɵɵpipe(5, "observablePipe");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_2_0;
            let tmp_5_0;
            i0.ɵɵproperty("label", ctx.filterConfig.showLabel ? ctx.filterConfig.label : "")("iconClass", ctx.filterConfig.icon)("showReset", ctx.formControl.value && ((tmp_2_0 = ctx.filterConfig.resetFilter) !== null && tmp_2_0 !== undefined ? tmp_2_0 : true));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("filter", true)("formControl", ctx.formControl)("autofocusFilter", (tmp_5_0 = ctx.filterConfig.autofocusFilter) !== null && tmp_5_0 !== undefined ? tmp_5_0 : true)("resetFilterOnHide", ctx.filterConfig.resetFilterOnHide || false)("disabled", i0.ɵɵpipeBind1(2, 12, i0.ɵɵpipeBind1(3, 14, ctx.filterConfig.disabled)))("options", i0.ɵɵpipeBind1(4, 16, i0.ɵɵpipeBind1(5, 18, ctx.filterConfig.options)))("sortAlphabetically", ctx.filterConfig.sortAlphabetically)("placeholder", ctx.filterConfig.placeholder);
            i0.ɵɵattribute("data-test", "filter-" + ctx.filterConfig.field);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.FormControlDirective, i2$1.CapturumDropdownComponent, CapturumDynamicFilterLayoutComponent, i1.AsyncPipe, i1$2.ObservablePipe],
        encapsulation: 2
      });
    }
  }
  return CapturumDropdownFilterComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumMultiSelectFilterComponent = /*#__PURE__*/(() => {
  class CapturumMultiSelectFilterComponent {
    constructor(cdr) {
      this.cdr = cdr;
      this.updateValue = new EventEmitter();
      this.formControl = new FormControl();
    }
    setValue(value) {
      this.formControl.setValue(value);
      this.cdr.detectChanges();
    }
    reset() {
      this.formControl.reset();
      this.updateValue.emit(this.formControl.value);
    }
    updateView() {
      this.cdr.detectChanges();
    }
    static {
      this.ɵfac = function CapturumMultiSelectFilterComponent_Factory(t) {
        return new (t || CapturumMultiSelectFilterComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumMultiSelectFilterComponent,
        selectors: [["cap-multi-select-filter"]],
        inputs: {
          filterConfig: "filterConfig"
        },
        decls: 6,
        vars: 24,
        consts: [[1, "dynamic-multiselect-filter", 3, "label", "iconClass", "showReset", "resetFilter"], [3, "filter", "formControl", "appendTo", "sortBy", "resetFilterOnHide", "autofocusFilter", "selectedItemsLabel", "maxSelectedLabels", "options", "defaultLabel", "disabled", "sortAlphabetically", "change"]],
        template: function CapturumMultiSelectFilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-dynamic-filter-layout", 0);
            i0.ɵɵlistener("resetFilter", function CapturumMultiSelectFilterComponent_Template_cap_dynamic_filter_layout_resetFilter_0_listener() {
              return ctx.reset();
            });
            i0.ɵɵelementStart(1, "cap-multi-select", 1);
            i0.ɵɵlistener("change", function CapturumMultiSelectFilterComponent_Template_cap_multi_select_change_1_listener($event) {
              return ctx.updateValue.emit($event.value);
            });
            i0.ɵɵpipe(2, "async");
            i0.ɵɵpipe(3, "observablePipe");
            i0.ɵɵpipe(4, "async");
            i0.ɵɵpipe(5, "observablePipe");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_2_0;
            let tmp_8_0;
            let tmp_10_0;
            i0.ɵɵproperty("label", ctx.filterConfig.showLabel ? ctx.filterConfig.label : "")("iconClass", ctx.filterConfig.icon)("showReset", ctx.formControl.value && ((tmp_2_0 = ctx.filterConfig.resetFilter) !== null && tmp_2_0 !== undefined ? tmp_2_0 : true));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("filter", true)("formControl", ctx.formControl)("appendTo", "body")("sortBy", "order")("resetFilterOnHide", ctx.filterConfig.resetFilterOnHide || false)("autofocusFilter", (tmp_8_0 = ctx.filterConfig.autofocusFilter) !== null && tmp_8_0 !== undefined ? tmp_8_0 : true)("selectedItemsLabel", ctx.filterConfig.selectedItemsLabel || "{0} items selected")("maxSelectedLabels", (tmp_10_0 = ctx.filterConfig.maxSelectedLabels) !== null && tmp_10_0 !== undefined ? tmp_10_0 : 1)("options", i0.ɵɵpipeBind1(2, 16, i0.ɵɵpipeBind1(3, 18, ctx.filterConfig.options)))("defaultLabel", ctx.filterConfig.placeholder)("disabled", i0.ɵɵpipeBind1(4, 20, i0.ɵɵpipeBind1(5, 22, ctx.filterConfig.disabled)))("sortAlphabetically", ctx.filterConfig.sortAlphabetically);
            i0.ɵɵattribute("data-test", "filter-" + ctx.filterConfig.field);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.FormControlDirective, i2$2.CapturumMultiSelectComponent, CapturumDynamicFilterLayoutComponent, i1.AsyncPipe, i1$2.ObservablePipe],
        encapsulation: 2
      });
    }
  }
  return CapturumMultiSelectFilterComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DateFilterSelectionModePipe = /*#__PURE__*/(() => {
  class DateFilterSelectionModePipe {
    transform(matchMode) {
      if (matchMode === FilterMatchMode.BETWEEN || matchMode === FilterMatchMode.DATEBETWEEN) {
        return 'range';
      }
      return 'single';
    }
    static {
      this.ɵfac = function DateFilterSelectionModePipe_Factory(t) {
        return new (t || DateFilterSelectionModePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "dateFilterSelectionModePipe",
        type: DateFilterSelectionModePipe,
        pure: true
      });
    }
  }
  return DateFilterSelectionModePipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CalendarFilterComponent = /*#__PURE__*/(() => {
  class CalendarFilterComponent {
    constructor(cdr, datePipe) {
      this.cdr = cdr;
      this.datePipe = datePipe;
      this.updateValue = new EventEmitter();
      this.formControl = new FormControl();
    }
    setValue(value) {
      this.formControl.setValue(value);
      this.cdr.detectChanges();
    }
    reset() {
      this.formControl.setValue(null);
      this.updateValue.emit(this.formControl.value);
    }
    handleDateFilterChange(filterMatchMode) {
      if (filterMatchMode === FilterMatchMode.BETWEEN || filterMatchMode === FilterMatchMode.DATEBETWEEN) {
        const dateValues = this.formControl.value.map(date => this.datePipe.transform(date, DateFormat.generalReverse));
        if (dateValues.length === 2 && dateValues.every(Boolean)) {
          this.updateValue.emit(dateValues);
        }
      } else {
        this.updateValue.emit(this.datePipe.transform(this.formControl.value, DateFormat.generalReverse));
      }
      this.cdr.detectChanges();
    }
    updateView() {
      this.cdr.detectChanges();
    }
    static {
      this.ɵfac = function CalendarFilterComponent_Factory(t) {
        return new (t || CalendarFilterComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.DatePipe));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CalendarFilterComponent,
        selectors: [["cap-calendar-filter"]],
        inputs: {
          filterConfig: "filterConfig"
        },
        decls: 9,
        vars: 33,
        consts: [[1, "dynamic-calendar-filter", 3, "label", "iconClass", "showReset", "resetFilter"], [3, "readonlyInput", "formControl", "hideOnDateTimeSelect", "showIcon", "appendTo", "minDate", "maxDate", "hideOnRangeSelect", "icon", "view", "dateFormat", "disabled", "setTimeZone", "selectionMode", "placeholder", "select"]],
        template: function CalendarFilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-dynamic-filter-layout", 0);
            i0.ɵɵlistener("resetFilter", function CalendarFilterComponent_Template_cap_dynamic_filter_layout_resetFilter_0_listener() {
              return ctx.reset();
            });
            i0.ɵɵelementStart(1, "cap-calendar", 1);
            i0.ɵɵlistener("select", function CalendarFilterComponent_Template_cap_calendar_select_1_listener() {
              return ctx.handleDateFilterChange(ctx.filterConfig.matchMode);
            });
            i0.ɵɵpipe(2, "async");
            i0.ɵɵpipe(3, "observablePipe");
            i0.ɵɵpipe(4, "async");
            i0.ɵɵpipe(5, "observablePipe");
            i0.ɵɵpipe(6, "async");
            i0.ɵɵpipe(7, "observablePipe");
            i0.ɵɵpipe(8, "dateFilterSelectionModePipe");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_2_0;
            let tmp_15_0;
            i0.ɵɵproperty("label", ctx.filterConfig.showLabel ? ctx.filterConfig.label : "")("iconClass", ctx.filterConfig.icon)("showReset", ctx.formControl.value && ((tmp_2_0 = ctx.filterConfig.resetFilter) !== null && tmp_2_0 !== undefined ? tmp_2_0 : true));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("readonlyInput", true)("formControl", ctx.formControl)("hideOnDateTimeSelect", true)("showIcon", true)("appendTo", "body")("minDate", i0.ɵɵpipeBind1(2, 19, i0.ɵɵpipeBind1(3, 21, ctx.filterConfig.minDate)))("maxDate", i0.ɵɵpipeBind1(4, 23, i0.ɵɵpipeBind1(5, 25, ctx.filterConfig.maxDate)))("hideOnRangeSelect", true)("icon", "pi pi-chevron-down")("view", ctx.filterConfig.view || "date")("dateFormat", ctx.filterConfig.dateFormat || "dd-mm-yy")("disabled", i0.ɵɵpipeBind1(6, 27, i0.ɵɵpipeBind1(7, 29, ctx.filterConfig.disabled)))("setTimeZone", (tmp_15_0 = ctx.filterConfig.timezone) !== null && tmp_15_0 !== undefined ? tmp_15_0 : true)("selectionMode", i0.ɵɵpipeBind1(8, 31, ctx.filterConfig.matchMode))("placeholder", ctx.filterConfig.placeholder);
            i0.ɵɵattribute("data-test", "filter-" + ctx.filterConfig.field);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.FormControlDirective, i3.CapturumCalendarComponent, CapturumDynamicFilterLayoutComponent, i1.AsyncPipe, i1$2.ObservablePipe, DateFilterSelectionModePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CalendarFilterComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var DynamicFilterType = /*#__PURE__*/function (DynamicFilterType) {
  DynamicFilterType["input"] = "input";
  DynamicFilterType["checkbox"] = "checkbox";
  DynamicFilterType["dropdown"] = "dropdown";
  DynamicFilterType["multiselect"] = "multiselect";
  DynamicFilterType["date"] = "date";
  DynamicFilterType["range"] = "range";
  DynamicFilterType["datetimeduration"] = "datetimerange";
  return DynamicFilterType;
}(DynamicFilterType || {});
let DynamicRangeFilterComponent = /*#__PURE__*/(() => {
  class DynamicRangeFilterComponent {
    constructor(cdr) {
      this.cdr = cdr;
      this.updateValue = new EventEmitter();
      this.formControl = new FormControl();
      this.showReset = true;
      this.onReset = new EventEmitter();
    }
    setValue(value) {
      if (!value) {
        this.formControl.setValue(undefined);
      } else {
        this.formControl.setValue({
          value
        });
      }
    }
    reset() {
      this.rangeFilter.reset();
      this.formControl.reset();
      this.onReset.emit();
      this.updateValue.emit(null);
    }
    handleRangeChange(value) {
      this.formControl.setValue([value.from, value.to], {
        emitEvent: false
      });
      this.updateValue.emit([value.from, value.to]);
    }
    updateView() {
      this.cdr.detectChanges();
    }
    static {
      this.ɵfac = function DynamicRangeFilterComponent_Factory(t) {
        return new (t || DynamicRangeFilterComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicRangeFilterComponent,
        selectors: [["cap-dynamic-range-filter"]],
        viewQuery: function DynamicRangeFilterComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(RangeFilterComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rangeFilter = _t.first);
          }
        },
        inputs: {
          formControl: "formControl",
          filterConfig: "filterConfig",
          showReset: "showReset",
          showLabel: "showLabel"
        },
        outputs: {
          updateValue: "updateValue",
          onReset: "onReset"
        },
        decls: 2,
        vars: 14,
        consts: [[1, "cap-dynamic-input-filter", 3, "iconClass", "label", "showReset", "resetFilter"], [3, "mask", "toLabel", "formControl", "updateOnClose", "isNumbers", "placeholder", "isRangeBetweenDates", "confirmButtonText", "emptyMessage", "fromLabel", "change"]],
        template: function DynamicRangeFilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-dynamic-filter-layout", 0);
            i0.ɵɵlistener("resetFilter", function DynamicRangeFilterComponent_Template_cap_dynamic_filter_layout_resetFilter_0_listener() {
              return ctx.reset();
            });
            i0.ɵɵelementStart(1, "cap-range-filter", 1);
            i0.ɵɵlistener("change", function DynamicRangeFilterComponent_Template_cap_range_filter_change_1_listener($event) {
              return ctx.handleRangeChange($event);
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_2_0;
            i0.ɵɵproperty("iconClass", ctx.filterConfig.icon)("label", ctx.showLabel ? ctx.filterConfig.label : null)("showReset", ctx.formControl.value && ((tmp_2_0 = ctx.filterConfig.resetFilter) !== null && tmp_2_0 !== undefined ? tmp_2_0 : true));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("mask", ctx.filterConfig == null ? null : ctx.filterConfig.mask)("toLabel", ctx.filterConfig.toLabel || "To")("formControl", ctx.formControl)("updateOnClose", false)("isNumbers", false)("placeholder", ctx.filterConfig.placeholder)("isRangeBetweenDates", false)("confirmButtonText", ctx.filterConfig.confirmButtonText || "OK")("emptyMessage", ctx.filterConfig.emptyMessage || "Empty is no limit")("fromLabel", ctx.filterConfig.fromLabel || "From");
            i0.ɵɵattribute("data-test", "filter-" + ctx.filterConfig.field);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.FormControlDirective, i2$3.RangeFilterComponent, CapturumDynamicFilterLayoutComponent],
        encapsulation: 2
      });
    }
  }
  return DynamicRangeFilterComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CheckboxFilterComponent = /*#__PURE__*/(() => {
  class CheckboxFilterComponent {
    constructor(cdr) {
      this.cdr = cdr;
      this.updateValue = new EventEmitter();
      this.formControl = new FormControl();
    }
    setValue(value) {
      this.formControl.setValue(value, {
        emitEvent: false
      });
      this.cdr.detectChanges();
    }
    reset() {
      this.formControl.setValue(null);
      this.updateValue.emit(null);
    }
    updateView() {
      this.cdr.detectChanges();
    }
    static {
      this.ɵfac = function CheckboxFilterComponent_Factory(t) {
        return new (t || CheckboxFilterComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckboxFilterComponent,
        selectors: [["cap-checkbox-filter"]],
        inputs: {
          filterConfig: "filterConfig"
        },
        decls: 6,
        vars: 10,
        consts: [[1, "cap-dynamic-checkbox-filter", 3, "iconClass", "showReset", "resetFilter"], [1, "cap-checkbox-filter-label"], [3, "formControl", "disabled", "change"]],
        template: function CheckboxFilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-dynamic-filter-layout", 0);
            i0.ɵɵlistener("resetFilter", function CheckboxFilterComponent_Template_cap_dynamic_filter_layout_resetFilter_0_listener() {
              return ctx.reset();
            });
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "cap-checkbox", 2);
            i0.ɵɵlistener("change", function CheckboxFilterComponent_Template_cap_checkbox_change_3_listener($event) {
              return ctx.updateValue.emit($event.checked);
            });
            i0.ɵɵpipe(4, "async");
            i0.ɵɵpipe(5, "observablePipe");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("iconClass", ctx.filterConfig.icon)("showReset", false);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.filterConfig == null ? null : ctx.filterConfig.label, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControl", ctx.formControl)("disabled", i0.ɵɵpipeBind1(4, 6, i0.ɵɵpipeBind1(5, 8, ctx.filterConfig.disabled)));
            i0.ɵɵattribute("data-test", "filter-" + ctx.filterConfig.field);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.FormControlDirective, i2$4.CapturumCheckboxComponent, CapturumDynamicFilterLayoutComponent, i1.AsyncPipe, i1$2.ObservablePipe],
        styles: [":root{--cap-input-height: 30px;--cap-dynamic-filter-input-height: 30px;--cap-dynamic-filter-border-radius: 5px;--cap-dynamic-filter-border-width: 1px;--cap-dynamic-filters-hide-filters-on-mobile: false;--cap-dynamic-filters-filter-flex: 1;--cap-dynamic-filters-flex-wrap: wrap;--cap-dynamic-filter-width: 200px;--cap-dynamic-filter-label-font-size: 14px;--cap-dynamic-filter-label-font-weight: 600;--cap-dynamic-filter-label-font-family: \"Source Sans Pro\";--cap-dynamic-filter-label-font-color: #5f6062;--cap-dynamic-filter-placeholder-font-weight: 600;--cap-dynamic-filter-placeholder-font-color: #5f6062;--cap-dynamic-filter-icon-opacity: 1;--cap-dynamic-filter-icon-color: var(--cap-primary-color)}.cap-dynamic-input-filter cap-validator{display:none}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckboxFilterComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumDateTimeDurationFilterComponent = /*#__PURE__*/(() => {
  class CapturumDateTimeDurationFilterComponent {
    constructor() {
      this.formControl = new FormControl();
      this.showReset = true;
      this.updateValue = new EventEmitter();
      this.cdr = inject(ChangeDetectorRef);
      this.datePipe = inject(DatePipe);
    }
    setValue(value) {
      let storedValue = null;
      // convert date array to duration string
      if (Array.isArray(value) && value.length > 1) {
        const startDate = new Date(value[0]).toISOString();
        const endDate = new Date(value[1]).toISOString();
        if (isValid(new Date(startDate)) && isValid(new Date(endDate))) {
          const intervalDuration = intervalToDuration({
            start: new Date(startDate),
            end: new Date(endDate)
          });
          storedValue = isBefore(new Date(startDate), new Date(endDate)) ? `-${toString(intervalDuration)}` : toString(intervalDuration);
        }
      }
      this.formControl.setValue(storedValue);
      this.cdr.detectChanges();
    }
    reset() {
      this.formControl.reset();
      this.updateValue.emit(null);
    }
    changeSelection(duration) {
      this.duration = duration;
      const dateNow = new Date().toISOString();
      const dateTo = this.datePipe.transform(dateNow, 'yyyy-MM-dd HH:mm:ss', '+0000');
      const dateFrom = this.datePipe.transform(apply(dateNow, parse(this.duration)), 'yyyy-MM-dd HH:mm:ss', '+0000');
      this.updateValue.emit([dateFrom, dateTo]);
    }
    updateView() {
      this.cdr.detectChanges();
    }
    static {
      this.ɵfac = function CapturumDateTimeDurationFilterComponent_Factory(t) {
        return new (t || CapturumDateTimeDurationFilterComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumDateTimeDurationFilterComponent,
        selectors: [["cap-date-time-dynamic-duration-filter"]],
        inputs: {
          formControl: "formControl",
          showReset: "showReset",
          showLabel: "showLabel",
          filterConfig: "filterConfig"
        },
        outputs: {
          updateValue: "updateValue"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([DatePipe]), i0.ɵɵStandaloneFeature],
        decls: 6,
        vars: 21,
        consts: [[1, "dynamic-dropdown-filter", 3, "iconClass", "label", "showReset", "resetFilter"], [3, "filter", "formControl", "autoDisplayFirst", "autofocusFilter", "resetFilterOnHide", "disabled", "options", "sortAlphabetically", "placeholder", "changeSelection"]],
        template: function CapturumDateTimeDurationFilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-dynamic-filter-layout", 0);
            i0.ɵɵlistener("resetFilter", function CapturumDateTimeDurationFilterComponent_Template_cap_dynamic_filter_layout_resetFilter_0_listener() {
              return ctx.reset();
            });
            i0.ɵɵelementStart(1, "cap-dropdown", 1);
            i0.ɵɵlistener("changeSelection", function CapturumDateTimeDurationFilterComponent_Template_cap_dropdown_changeSelection_1_listener($event) {
              return ctx.changeSelection($event.value);
            });
            i0.ɵɵpipe(2, "async");
            i0.ɵɵpipe(3, "observablePipe");
            i0.ɵɵpipe(4, "async");
            i0.ɵɵpipe(5, "observablePipe");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_2_0;
            let tmp_6_0;
            i0.ɵɵproperty("iconClass", ctx.filterConfig.icon)("label", ctx.showLabel ? ctx.filterConfig.label : null)("showReset", ctx.formControl.value && ((tmp_2_0 = ctx.filterConfig.resetFilter) !== null && tmp_2_0 !== undefined ? tmp_2_0 : true));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("filter", true)("formControl", ctx.formControl)("autoDisplayFirst", false)("autofocusFilter", (tmp_6_0 = ctx.filterConfig.autofocusFilter) !== null && tmp_6_0 !== undefined ? tmp_6_0 : true)("resetFilterOnHide", ctx.filterConfig.resetFilterOnHide || false)("disabled", i0.ɵɵpipeBind1(2, 13, i0.ɵɵpipeBind1(3, 15, ctx.filterConfig.disabled)))("options", i0.ɵɵpipeBind1(4, 17, i0.ɵɵpipeBind1(5, 19, ctx.filterConfig.options)))("sortAlphabetically", false)("placeholder", ctx.filterConfig.placeholder);
            i0.ɵɵattribute("data-test", "filter-" + ctx.filterConfig.field);
          }
        },
        dependencies: [CommonModule, i1.AsyncPipe, CapturumDropdownModule, i2$1.CapturumDropdownComponent, FormsModule, i1$1.NgControlStatus, ReactiveFormsModule, i1$1.FormControlDirective, CapturumSharedModule, i1$2.ObservablePipe, CapturumDynamicFilterLayoutComponent],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CapturumDateTimeDurationFilterComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const dynamicFilterComponents = [{
  name: DynamicFilterType.input,
  component: InputFilterComponent
}, {
  name: DynamicFilterType.dropdown,
  component: CapturumDropdownFilterComponent
}, {
  name: DynamicFilterType.multiselect,
  component: CapturumMultiSelectFilterComponent
}, {
  name: DynamicFilterType.date,
  component: CalendarFilterComponent
}, {
  name: DynamicFilterType.range,
  component: DynamicRangeFilterComponent
}, {
  name: DynamicFilterType.checkbox,
  component: CheckboxFilterComponent
}, {
  name: DynamicFilterType.datetimeduration,
  component: CapturumDateTimeDurationFilterComponent
}];
let DynamicFiltersService = /*#__PURE__*/(() => {
  class DynamicFiltersService {
    constructor() {
      this.dynamicFilterActiveFilterChange$ = new ReplaySubject(10);
    }
    setActiveFilterValueChanged(activeFilter) {
      this.dynamicFilterActiveFilterChange$.next(activeFilter);
    }
    getActiveFilterDependencies(filterConfig) {
      return this.dynamicFilterActiveFilterChange$.asObservable().pipe(filter$1(activeFilter => {
        return activeFilter && filterConfig.dependsOn?.includes(activeFilter.field);
      }));
    }
    static {
      this.ɵfac = function DynamicFiltersService_Factory(t) {
        return new (t || DynamicFiltersService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DynamicFiltersService,
        factory: DynamicFiltersService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DynamicFiltersService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumDynamicFilterComponent = /*#__PURE__*/(() => {
  class CapturumDynamicFilterComponent {
    constructor(viewContainerRef, dynamicFiltersService, dynamicFilterComponentsMap) {
      this.viewContainerRef = viewContainerRef;
      this.dynamicFiltersService = dynamicFiltersService;
      this.dynamicFilterComponentsMap = dynamicFilterComponentsMap;
      this.updateValue = new EventEmitter();
      this.destroy$ = new Subject();
      this.updateValueSubject = new BehaviorSubject(null);
      this._dynamicFilterComponents = dynamicFilterComponentsMap || dynamicFilterComponents;
    }
    set activeFilter(filter) {
      this.updateValueSubject.next(filter?.value || null);
    }
    get filterConfig() {
      return this._filterConfig;
    }
    set filterConfig(value) {
      this._filterConfig = value;
      this.loadComponent(value);
    }
    ngOnDestroy() {
      this.destroy$.next(null);
      this.destroy$.complete();
    }
    loadComponent(filterConfigItem) {
      const component = this.findComponentByName(filterConfigItem.type);
      const viewContainerRef = this.viewContainerRef;
      if (filterConfigItem.dependsOn?.length && !filterConfigItem.preventDisableDependency) {
        filterConfigItem.disabled = true;
      }
      viewContainerRef.clear();
      if (component) {
        const componentReference = viewContainerRef.createComponent(component);
        this.componentInstance = componentReference.instance;
        componentReference.instance.filterConfig = filterConfigItem;
        componentReference.instance.updateValue.pipe(takeUntil$1(this.destroy$)).subscribe(value => {
          this.handleFilterChange(filterConfigItem, value);
        });
        this.dynamicFiltersService.getActiveFilterDependencies(filterConfigItem).pipe(distinctUntilKeyChanged('value', (prev, next) => {
          return JSON.stringify(prev) === JSON.stringify(next);
        }), takeUntil$1(this.destroy$)).subscribe(activeFilter => {
          const emptyFilterValue = activeFilter.value === null || Array.isArray(activeFilter.value) && !activeFilter.value.length;
          if (!filterConfigItem.preventDisableDependency) {
            filterConfigItem.disabled = emptyFilterValue;
            filterConfigItem.disabled ? this.componentInstance.formControl.disable({
              emitEvent: false
            }) : this.componentInstance.formControl.enable({
              emitEvent: false
            });
            this.componentInstance.updateView();
          }
          componentReference.setInput('filterConfig', filterConfigItem);
          this.componentInstance.filterConfig = filterConfigItem;
          const listOptions = emptyFilterValue ? null : {
            filters: [{
              field: activeFilter?.field,
              value: activeFilter?.value,
              operator: FilterMatchMode.IN
            }]
          };
          if (emptyFilterValue) {
            this.componentInstance.setValue(null);
            this.updateValue.emit({
              field: filterConfigItem.field,
              value: null
            });
          }
          if (filterConfigItem.updateListOptions) {
            filterConfigItem.options = filterConfigItem.updateListOptions(listOptions);
          }
        });
        this.updateValueSubject.asObservable().pipe(takeUntil$1(this.destroy$)).subscribe(value => {
          this.dynamicFiltersService.setActiveFilterValueChanged({
            field: filterConfigItem.field,
            value: value
          });
          this.componentInstance.setValue(value);
        });
      } else {
        throw Error(`Filter type ${filterConfigItem.type} not found. Make sure to provide this filter in the forRoot config of the CapturumDynamicFiltersModule`);
      }
    }
    handleFilterChange(filterConfigItem, value) {
      const newFilterValue = filterConfigItem.transformValue ? filterConfigItem.transformValue(value) : value;
      this.updateValue.emit({
        field: filterConfigItem.field,
        value: newFilterValue
      });
    }
    findComponentByName(name) {
      const componentMap = this._dynamicFilterComponents.find(componentMap => componentMap.name === name);
      return componentMap?.component || null;
    }
    static {
      this.ɵfac = function CapturumDynamicFilterComponent_Factory(t) {
        return new (t || CapturumDynamicFilterComponent)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(DynamicFiltersService), i0.ɵɵdirectiveInject(DYNAMIC_FILTER_COMPONENTS, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumDynamicFilterComponent,
        selectors: [["cap-dynamic-filter"]],
        inputs: {
          activeFilter: "activeFilter",
          filterConfig: "filterConfig"
        },
        outputs: {
          updateValue: "updateValue"
        },
        decls: 0,
        vars: 0,
        template: function CapturumDynamicFilterComponent_Template(rf, ctx) {}
      });
    }
  }
  return CapturumDynamicFilterComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class DynamicFiltersUtils {
  static generateStaticQueryUrlFromActiveFilters(filters) {
    let queryParams = {};
    filters.forEach(filter => {
      let filterValue = filter.value;
      if (filter.value && Array.isArray(filter.value)) {
        filterValue = [...filter.value].join(',');
      }
      queryParams = {
        ...queryParams,
        [`[staticFilter][${filter.field}][${filter.matchMode || ''}]`]: filterValue
      };
    });
    return queryParams;
  }
  static generateQueryUrlFromActiveFilters(filters) {
    let queryParams = {};
    filters.forEach(filter => {
      let filterValue = filter.value;
      if (filter.value && Array.isArray(filter.value)) {
        filterValue = [...filter.value].join(',');
      }
      queryParams = {
        ...queryParams,
        [`[filter][${filter.field}][${filter.matchMode || ''}]`]: filterValue
      };
    });
    return queryParams;
  }
  static retrieveQueryParamFilters(queryParams, staticFilters = false, tableKey) {
    const activeFilters = Object.keys(queryParams).reduce((agg, key) => {
      let splitByOpeningBracket = key.split('[');
      splitByOpeningBracket.shift();
      if (splitByOpeningBracket?.length && splitByOpeningBracket[0].includes(staticFilters ? 'staticFilter' : 'filter')) {
        splitByOpeningBracket = splitByOpeningBracket.map(item => {
          return item.replace(']', '');
        });
        const field = splitByOpeningBracket[1];
        const matchMode = splitByOpeningBracket[2];
        const value = matchMode === FilterMatchMode.EQUALS || matchMode === FilterMatchMode.LIKE || matchMode === FilterMatchMode.NOT_LIKE || matchMode === FilterMatchMode.DATEEQUALS ? queryParams[key] : queryParams[key].split(',');
        if (splitByOpeningBracket[3] && tableKey && `${splitByOpeningBracket[3]}` !== `${tableKey}`) {
          return;
        }
        agg.push({
          field,
          value,
          matchMode
        });
      }
      return agg;
    }, []) || [];
    return activeFilters;
  }
}
let FilterFieldPipe = /*#__PURE__*/(() => {
  class FilterFieldPipe {
    transform(value, field) {
      return value?.find(filter => filter.field === field);
    }
    static {
      this.ɵfac = function FilterFieldPipe_Factory(t) {
        return new (t || FilterFieldPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "filterField",
        type: FilterFieldPipe,
        pure: true
      });
    }
  }
  return FilterFieldPipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicFiltersSidebarComponent = /*#__PURE__*/(() => {
  class DynamicFiltersSidebarComponent {
    constructor(localStorageService) {
      this.localStorageService = localStorageService;
      this.filterChange = new EventEmitter();
      this.cancelClick = new EventEmitter();
      this._activeFilters = [];
    }
    get filterConfig() {
      return this._filterConfig;
    }
    set filterConfig(value) {
      this._filterConfig = {
        ...value,
        filters: value.filters.map(filterConfig => {
          return {
            ...filterConfig,
            showLabel: true
          };
        })
      };
    }
    get activeFilters() {
      return this._activeFilters;
    }
    set activeFilters(value) {
      this._activeFilters = value;
      this._originalFilterValue = value;
    }
    ngOnInit() {
      const hiddenFilterKeys = this.localStorageService.getItem(this.getShownFiltersStorageKey());
      if (!hiddenFilterKeys) {
        this.shownFilters = this._filterConfig.filters.filter(filter => {
          return !filter.hidden;
        });
        this.hiddenFilters = this._filterConfig.filters.filter(filter => {
          return filter.hidden;
        });
      } else {
        this.shownFilters = this._filterConfig.filters.filter(filter => {
          return !hiddenFilterKeys.includes(filter.field);
        });
        this.hiddenFilters = this._filterConfig.filters.filter(filter => {
          return hiddenFilterKeys.includes(filter.field);
        });
      }
    }
    setSidebarFilter(updatedFilter) {
      if (!this._activeFilters.some(filter => filter.field === updatedFilter.field)) {
        this._activeFilters = [...this._activeFilters, {
          ...updatedFilter,
          matchMode: this._filterConfig.filters.find(filter => filter.field === updatedFilter.field)?.matchMode
        }];
      } else {
        this._activeFilters = this._activeFilters.reduce((acc, filter) => {
          if (filter.field === updatedFilter.field) {
            return [...acc, {
              ...filter,
              value: updatedFilter.value
            }];
          }
          return [...acc, filter];
        }, []);
      }
    }
    applyFilters() {
      this.filterChange.emit(this._activeFilters);
    }
    cancel() {
      this._activeFilters = this._originalFilterValue;
      this.cancelClick.emit();
    }
    reset() {
      this._activeFilters = this._originalFilterValue;
    }
    getShownFiltersStorageKey() {
      return `${this.storageKey}-hiddenFilters`;
    }
    static {
      this.ɵfac = function DynamicFiltersSidebarComponent_Factory(t) {
        return new (t || DynamicFiltersSidebarComponent)(i0.ɵɵdirectiveInject(i1$2.LocalStorageService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicFiltersSidebarComponent,
        selectors: [["cap-dynamic-filters-sidebar"]],
        inputs: {
          storageKey: "storageKey",
          filterStyleClass: "filterStyleClass",
          filterConfig: "filterConfig",
          activeFilters: "activeFilters"
        },
        outputs: {
          filterChange: "filterChange",
          cancelClick: "cancelClick"
        },
        decls: 11,
        vars: 5,
        consts: [[1, "filter-sidebar"], [1, "cap-filters"], [1, "shown-filters", "filter-list", "sidebar-filter-list"], [3, "class", "ngClass", 4, "ngFor", "ngForOf"], [1, "hidden-filters", "filter-list", "sidebar-filter-list"], [1, "sidebar-filter-buttons"], ["styleClass", "secondary", 3, "label", "onClick"], [1, "sidebar-filter-right-buttons"], ["styleClass", "primary", "icon", "fas fa-check", 3, "label", "onClick"], [3, "ngClass"], [3, "activeFilter", "filterConfig", "updateValue"]],
        template: function DynamicFiltersSidebarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtemplate(3, DynamicFiltersSidebarComponent_div_3_Template, 3, 13, "div", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 4);
            i0.ɵɵtemplate(5, DynamicFiltersSidebarComponent_div_5_Template, 3, 13, "div", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 5)(7, "cap-button", 6);
            i0.ɵɵlistener("onClick", function DynamicFiltersSidebarComponent_Template_cap_button_onClick_7_listener() {
              return ctx.cancel();
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 7)(9, "cap-button", 6);
            i0.ɵɵlistener("onClick", function DynamicFiltersSidebarComponent_Template_cap_button_onClick_9_listener() {
              return ctx.reset();
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "cap-button", 8);
            i0.ɵɵlistener("onClick", function DynamicFiltersSidebarComponent_Template_cap_button_onClick_10_listener() {
              return ctx.applyFilters();
            });
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.shownFilters);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.hiddenFilters);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", (ctx.filterConfig.texts == null ? null : ctx.filterConfig.texts.cancel) || "Cancel");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", (ctx.filterConfig.texts == null ? null : ctx.filterConfig.texts.reset) || "Reset");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("label", (ctx.filterConfig.texts == null ? null : ctx.filterConfig.texts.apply) || "Apply");
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i3$1.CapturumButtonComponent, CapturumDynamicFilterComponent, FilterFieldPipe],
        styles: ["cap-dynamic-filters .filter-sidebar .cap-filters{display:block}cap-dynamic-filters .filter-sidebar .cap-filters .filter-list{flex-wrap:wrap}cap-dynamic-filters .filter-sidebar .cap-filters .filter-list .filter{flex:none}cap-dynamic-filters .filter-sidebar .cap-filters .draggable-filters .draggable-filter-header{display:block}cap-dynamic-filters .filter-sidebar .cap-filters .draggable-filters .sidebar-filter.filter{padding-right:0}cap-dynamic-filters .filter-sidebar .cap-filters .draggable-filters .cap-dynamic-filter-layout{padding:5px}cap-dynamic-filters .filter-sidebar .cap-filters .draggable-filters.filter-list{border:1px solid #ddd;width:100%;min-height:300px;border-radius:3px;padding:10px}cap-dynamic-filters .filter-sidebar .cap-filters .draggable-filters .sidebar-filter{background:#f9f9f9;border:1px solid #ddd;border-radius:3px;cursor:move}.cdk-drag-disabled .draggable-filter-header{display:none}.cdk-drag .draggable-filter-header:not(.cdk-drag-disabled){background:#ddd;padding:5px;font-weight:700}.sidebar-filter-buttons{border-top:1px solid #ddd;position:absolute;bottom:0;left:0;right:0;padding:20px;display:flex;justify-content:space-between}.sidebar-filter-buttons .sidebar-filter-right-buttons{width:50%;display:flex;justify-content:space-between}\n"],
        encapsulation: 2
      });
    }
  }
  return DynamicFiltersSidebarComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumDynamicFiltersComponent = /*#__PURE__*/(() => {
  class CapturumDynamicFiltersComponent {
    get activeFilters() {
      return this._activeFilters;
    }
    set activeFilters(filters) {
      this._activeFilters = filters;
    }
    constructor(tableRouteConfigService, activatedRoute, localStorageService) {
      this.tableRouteConfigService = tableRouteConfigService;
      this.activatedRoute = activatedRoute;
      this.localStorageService = localStorageService;
      /**
       * The configuration of the filters that should be rendered
       */
      this.filterConfig = {
        filters: []
      };
      /**
       * Define whether the reset button should be shown
       */
      this.routeFilters = false;
      /**
       * The style class to be applied to the container element of the filters
       */
      this.containerStyleClass = '';
      /**
       * The style class to be applied to each individual filter component
       */
      this.filterStyleClass = '';
      /**
       * Define whether the reset button should be shown
       */
      this.showResetButton = true;
      /**
      * Define whether the refresh button should be shown
      */
      this.showRefreshButton = true;
      this.maxFiltersShown = 40;
      this.filteredTokens = [];
      /**
       * Callback to execute whenever any of the filter values change
       */
      this.activeFiltersChange = new EventEmitter();
      this.maxTokens = 10;
      this.sidebarFiltering = false;
      this.onResetFilters = new EventEmitter();
      this.SEARCH_BAR = 'global_search';
      this.activeSidebarFilters = [];
      this.showFilters = [];
      this.hideFilters = [];
      this._activeFilters = [];
    }
    ngOnInit() {
      let storageFilters = [];
      if (this.routeFilters) {
        storageFilters = this.retrieveFiltersFromQueryParams();
        if (!storageFilters.length) {
          storageFilters = this.getStorageFilters();
        }
      } else if (this.storageKey) {
        storageFilters = this.getStorageFilters();
      }
      if (storageFilters.length) {
        this._activeFilters = storageFilters.reduce((acc, storageFilter) => {
          const activeFilter = this._activeFilters.find(activeFilter => activeFilter.field === storageFilter.field);
          if (!activeFilter && (Array.isArray(storageFilter?.value) ? storageFilter?.value?.length : storageFilter?.value !== undefined && storageFilter.value !== null)) {
            return [...acc, storageFilter];
          }
          return acc;
        }, this._activeFilters);
      } else if (this.filterConfig?.routeFilters?.length) {
        this._activeFilters = this.filterConfig?.routeFilters;
        if (this.routeFilters) {
          this.saveFiltersInQueryParams(this._activeFilters);
        }
        if (this.routeFilters || this.storageKey) {
          this.storeValues(this._activeFilters);
        }
      }
      this.filterConfig?.filters.forEach(filterConfig => {
        if (!this._activeFilters.find(activeFilter => activeFilter.field === filterConfig.field)) {
          if (filterConfig.default !== undefined) {
            this._activeFilters = [...this._activeFilters, {
              value: filterConfig.default,
              matchMode: filterConfig.matchMode,
              field: filterConfig.field
            }];
          }
        }
      });
      const shownFilterKeys = this.localStorageService.getItem(this.getShownFiltersStorageKey());
      if (!shownFilterKeys) {
        this.showFilters = this.filterConfig.filters.filter(filter => !filter.hidden);
      } else {
        this.showFilters = this.filterConfig.filters.filter(filter => {
          return shownFilterKeys.includes(filter.field);
        });
        this.hideFilters = this.filterConfig.filters.filter(filter => {
          return !shownFilterKeys.includes(filter.field);
        });
      }
      this.activeFiltersChange.emit(this._activeFilters);
      this.updateFilterTokens();
    }
    handleUpdateValue(updatedFilter) {
      if (!this._activeFilters.some(filter => filter.field === updatedFilter.field)) {
        this._activeFilters = [...this._activeFilters, {
          ...updatedFilter,
          matchMode: this.filterConfig.filters.find(filter => filter.field === updatedFilter.field)?.matchMode
        }];
      } else {
        this._activeFilters = this._activeFilters.reduce((acc, filter) => {
          if (filter.field === updatedFilter.field) {
            return [...acc, {
              ...filter,
              value: updatedFilter.value
            }];
          }
          return [...acc, filter];
        }, []);
      }
      this._activeFilters = this._activeFilters.filter(filter => Array.isArray(filter?.value) ? filter?.value?.length : filter?.value !== undefined && filter?.value !== null);
      if (this.routeFilters) {
        this.saveFiltersInQueryParams(this._activeFilters);
      }
      if (this.routeFilters || this.storageKey) {
        this.storeValues(this._activeFilters);
      }
      this.activeFiltersChange.emit(this._activeFilters);
      this.updateFilterTokens();
    }
    resetFilters() {
      this._activeFilters = this.getDefaultFilters() || [];
      if (this.filterConfig?.routeFilters?.length) {
        this._activeFilters = this.filterConfig.routeFilters;
      }
      if (this.routeFilters) {
        this.saveFiltersInQueryParams(this._activeFilters);
      }
      if (this.routeFilters || this.storageKey) {
        this.storeValues(this._activeFilters);
      }
      this.activeFiltersChange.emit(this._activeFilters);
      this.updateFilterTokens();
      this.onResetFilters.emit();
    }
    refreshFilters() {
      this.activeFiltersChange.emit(this._activeFilters);
    }
    openFilterSidebar() {
      this.showSidebar = true;
      this.activeSidebarFilters = [...this._activeFilters];
    }
    applySidebarFilters(filters) {
      this.showSidebar = false;
      this._activeFilters = filters.filter(filter => Array.isArray(filter?.value) ? filter?.value?.length : filter?.value !== undefined && filter?.value !== null);
      this.storeValues(this._activeFilters);
      this.activeFiltersChange.emit(this._activeFilters);
      this.updateFilterTokens();
    }
    handleSidebarFilterChange(filters) {
      this._activeFilters = filters;
    }
    removeFilter(removedFilter) {
      this.handleUpdateValue({
        ...removedFilter,
        value: null
      });
    }
    saveFiltersInQueryParams(filters) {
      const newFilters = [...filters];
      const previousFilters = this.retrieveFiltersFromQueryParams();
      // We have to update the already existing query params with null value
      // in order to delete them
      previousFilters.forEach(prevFilter => {
        const newFilter = newFilters.some(newFilter => newFilter.field === prevFilter.field);
        if (!newFilter) {
          newFilters.push({
            ...prevFilter,
            value: null
          });
        }
      });
      this.tableRouteConfigService.saveConfigInParams(DynamicFiltersUtils.generateQueryUrlFromActiveFilters(newFilters));
    }
    getStorageFilters() {
      const storageFilters = JSON.parse(localStorage.getItem(this.getFilterStorageKey()));
      return this.storageKey ? storageFilters || [] : [];
    }
    storeValues(filters) {
      localStorage.setItem(this.getFilterStorageKey(), JSON.stringify(filters));
    }
    getFilterStorageKey() {
      return `${this.storageKey}_filters`;
    }
    retrieveFiltersFromQueryParams() {
      return Object.keys(this.activatedRoute.snapshot.queryParams || {})?.length ? DynamicFiltersUtils.retrieveQueryParamFilters(this.activatedRoute.snapshot.queryParams) : [];
    }
    getDefaultFilters() {
      let activeFilters = [];
      this.filterConfig?.filters.forEach(filterConfig => {
        if (filterConfig.default !== undefined && filterConfig.default !== null) {
          activeFilters = [...activeFilters, {
            value: filterConfig.default,
            matchMode: filterConfig.matchMode,
            field: filterConfig.field
          }];
        }
      });
      return activeFilters;
    }
    getShownFiltersStorageKey() {
      return `${this.storageKey}-shownFilters`;
    }
    updateFilterTokens() {
      this.filteredTokens = this.activeFilters.slice(0, this.maxTokens).filter(filter => {
        return filter.value !== undefined && filter.value !== null && filter.value !== '';
      }).map(filter => ({
        ...filter,
        label: this.filterConfig?.filters?.find(filterConfig => filterConfig.field === filter.field)?.label
      }));
    }
    static {
      this.ɵfac = function CapturumDynamicFiltersComponent_Factory(t) {
        return new (t || CapturumDynamicFiltersComponent)(i0.ɵɵdirectiveInject(i1$2.TableRouteConfigService), i0.ɵɵdirectiveInject(i2$5.ActivatedRoute), i0.ɵɵdirectiveInject(i1$2.LocalStorageService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumDynamicFiltersComponent,
        selectors: [["cap-dynamic-filters"]],
        inputs: {
          filterConfig: "filterConfig",
          storageKey: "storageKey",
          routeFilters: "routeFilters",
          containerStyleClass: "containerStyleClass",
          filterStyleClass: "filterStyleClass",
          showResetButton: "showResetButton",
          showRefreshButton: "showRefreshButton",
          maxFiltersShown: "maxFiltersShown",
          maxTokens: "maxTokens",
          sidebarFiltering: "sidebarFiltering",
          activeFilters: "activeFilters"
        },
        outputs: {
          activeFiltersChange: "activeFiltersChange",
          onResetFilters: "onResetFilters"
        },
        features: [i0.ɵɵProvidersFeature([CapturumDialogService])],
        decls: 4,
        vars: 7,
        consts: [[3, "class", "sidebar-filtering", 4, "ngIf"], ["class", "dynamic-filter-chips", 4, "ngIf"], ["styleClass", "cap-dynamic-filters-sidebar", 3, "visible", "title", "visibleChange"], [3, "activeFilters", "filterConfig", "storageKey", "filterChange", "cancelClick"], [1, "filter-list"], [4, "ngFor", "ngForOf"], [1, "filter-button"], ["styleClass", "primary", "icon", "fas fa-filter", 1, "mr-2", "sidebar-filter-button", 3, "click"], ["class", "refresh-filter-button mr-2", "styleClass", "tertiary", 3, "icon", "label", "click", 4, "ngIf"], ["class", "reset-filter-button", "styleClass", "tertiary", 3, "icon", "label", "click", 4, "ngIf"], [3, "class", "ngClass", 4, "ngIf"], [3, "ngClass"], [3, "activeFilter", "filterConfig", "updateValue"], ["styleClass", "tertiary", 1, "refresh-filter-button", "mr-2", 3, "icon", "label", "click"], ["styleClass", "tertiary", 1, "reset-filter-button", 3, "icon", "label", "click"], [1, "dynamic-filter-chips"], ["styleClass", "table-filters-tokens", 3, "ngModel", "showClear", "inputStyle", "ngModelChange", "onRemove"], ["pTemplate", "item"]],
        template: function CapturumDynamicFiltersComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CapturumDynamicFiltersComponent_div_0_Template, 7, 10, "div", 0);
            i0.ɵɵtemplate(1, CapturumDynamicFiltersComponent_div_1_Template, 3, 4, "div", 1);
            i0.ɵɵelementStart(2, "cap-sidebar", 2);
            i0.ɵɵlistener("visibleChange", function CapturumDynamicFiltersComponent_Template_cap_sidebar_visibleChange_2_listener($event) {
              return ctx.showSidebar = $event;
            });
            i0.ɵɵelementStart(3, "cap-dynamic-filters-sidebar", 3);
            i0.ɵɵlistener("filterChange", function CapturumDynamicFiltersComponent_Template_cap_dynamic_filters_sidebar_filterChange_3_listener($event) {
              return ctx.applySidebarFilters($event);
            })("cancelClick", function CapturumDynamicFiltersComponent_Template_cap_dynamic_filters_sidebar_cancelClick_3_listener() {
              return ctx.showSidebar = false;
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.filterConfig.filters == null ? null : ctx.filterConfig.filters.length);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.sidebarFiltering);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("visible", ctx.showSidebar)("title", (ctx.filterConfig.texts == null ? null : ctx.filterConfig.texts.filters) || "Filters");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("activeFilters", ctx.activeFilters)("filterConfig", ctx.filterConfig)("storageKey", ctx.storageKey);
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1$1.NgControlStatus, i3$1.CapturumButtonComponent, i6.PrimeTemplate, i7.CapturumSidebarComponent, i8.Chips, i1$1.NgModel, CapturumDynamicFilterComponent, DynamicFiltersSidebarComponent, FilterFieldPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CapturumDynamicFiltersComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumDynamicFiltersModule = /*#__PURE__*/(() => {
  class CapturumDynamicFiltersModule {
    static forRoot(config) {
      return {
        ngModule: CapturumDynamicFiltersModule,
        providers: [{
          provide: DYNAMIC_FILTER_COMPONENTS,
          useValue: [...(config?.components || []), ...dynamicFilterComponents]
        }]
      };
    }
    static {
      this.ɵfac = function CapturumDynamicFiltersModule_Factory(t) {
        return new (t || CapturumDynamicFiltersModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumDynamicFiltersModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, ReactiveFormsModule, CapturumInputModule, CapturumButtonModule, CapturumSharedModule, CapturumDropdownModule, CapturumMultiSelectModule, CapturumCalendarModule, CapturumCheckboxModule, CapturumTableModule, SidebarModule, CapturumSidebarModule, DragDropModule, ChipsModule, FormsModule, CapturumInputSwitchModule, CapturumDynamicFilterLayoutComponent]
      });
    }
  }
  return CapturumDynamicFiltersModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CapturumDateTimeDurationFilterComponent, CapturumDynamicFilterComponent, CapturumDynamicFiltersComponent, CapturumDynamicFiltersModule, DYNAMIC_FILTER_COMPONENTS, DynamicFilterType, DynamicFiltersService, DynamicFiltersUtils, DynamicRangeFilterComponent, dynamicFilterComponents };
